import vAnchor from "./v-anchor.vue";

export default Vue => {
  Vue.component("v-anchor", vAnchor);
};
